export default "__VITE_ASSET__ybj0WZsn__ 300w, __VITE_ASSET__BUkMWMJk__ 500w, __VITE_ASSET__ASP6E4qm__ 800w";